import { VHCRecordLabourInput, VhcRecordLogService } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type CreateBreakLabourInput = {
  logId: number;
  itemId: number;
  requestBody?: VHCRecordLabourInput;
};

export const useSaveBreakLabourMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.postVhcRecordsItemsBrakesLabours, CreateBreakLabourInput>
) =>
  useMutationWithNotifications(
    ({ logId, itemId, requestBody }: CreateBreakLabourInput) =>
      VhcRecordLogService.postVhcRecordsItemsBrakesLabours(logId, itemId, requestBody),
    options
  );
